<script setup>
import { storeToRefs } from 'pinia'
import { computed } from 'vue'
import { useAuthStore } from '~/stores/auth'
import { useModalStore } from '~/stores/modal'
import { useMessageStore } from '~/stores/messages'

definePageMeta({
    pageName: 'center'
})

// Fetch route
const route = useRoute()
const centerRoute = computed(() => route.params?.centerUid)

// Get center details
const { data: centerDetails, suspense: centerDetailSuspense } = useFetchCenterDetails(centerRoute.value)

onServerPrefetch(async () => {
    await centerDetailSuspense()
})

// Seo
useSeoMeta({
    title: () => centerDetails.value?.centerName
})

// Auth
const authStore = useAuthStore()
const { isLoggedIn } = storeToRefs(authStore)

// Track Page Load
trackPageLoad({
    title: TRACKING_CONSTANTS.TITLES.HOME_PAGE,
    centerUid: centerDetails.value?.centerUid,
    centerName: centerDetails.value?.centerName,
    loginStatus: isLoggedIn.value ? TRACKING_CONSTANTS.MISC.LOGGED_IN : TRACKING_CONSTANTS.MISC.LOGGED_OUT
})

// Fetch messages
const messagesStore = useMessageStore()
const { messages: staticKeys } = storeToRefs(messagesStore)

// Define app download config
const commonAppContent = computed(() => {
    return {
        title: staticKeys.value?.account_gettheapp_fallback_headline,
        description: staticKeys.value?.account_gettheapp_fallback_copytext
    }
})

// Modal store
const modalStore = useModalStore()
const { toggleModal, addModalContent } = modalStore

// Show app teaser, depending on router query (appears if user clicks on universal or app link in newsletter etc. and gets redirected
const showAppTeaser = useRouteQuery('showModal')

if (showAppTeaser.value === 'appTeaser') {
    addModalContent(commonAppContent.value)
    toggleModal(true)
}
</script>

<template>
    <PageMainContainer :page-main-container-config="{ fullbleed: true }">
        <AppDownloadHeader />
        <HeroTeaser />
        <CenterDetail />
    </PageMainContainer>
</template>
